// src/components/ui/Toaster.tsx
import * as Toast from '@radix-ui/react-toast';
import { AnimatePresence, motion } from 'framer-motion';
import { useToastStore } from '@/lib/toast';

const TONE_STYLES = {
  success: 'bg-emerald-600 text-white',
  error: 'bg-rose-600 text-white',
  info: 'bg-foreground text-background',
} as const;

const TONE_ICON = { success: '✓', error: '✕', info: 'ℹ' } as const;

export function Toaster() {
  const items = useToastStore((s) => s.items);
  const dismiss = useToastStore((s) => s.dismiss);

  return (
    <Toast.Provider swipeDirection="down" duration={3000}>
      <AnimatePresence>
        {items.map((item) => (
          <Toast.Root
            asChild
            key={item.id}
            open
            onOpenChange={(open) => {
              if (!open) dismiss(item.id);
            }}
          >
            <motion.div
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 8 }}
              transition={{ type: 'spring', stiffness: 360, damping: 30 }}
              className={
                'pointer-events-auto flex items-center gap-2 rounded-full px-4 py-2 text-sm shadow-lg ' +
                TONE_STYLES[item.tone]
              }
            >
              <span aria-hidden>{TONE_ICON[item.tone]}</span>
              <Toast.Title className="font-medium">{item.message}</Toast.Title>
            </motion.div>
          </Toast.Root>
        ))}
      </AnimatePresence>
      {/* Bottom-anchored, sitting just above the 56px bottom TabBar. On the
          few routes where the TabBar is hidden (auth/capture) it just floats a
          little higher than strictly needed — harmless. */}
      <Toast.Viewport
        className="pointer-events-none fixed left-1/2 z-[60] flex max-w-[90vw] -translate-x-1/2 flex-col items-center gap-2 outline-none"
        style={{ bottom: 'calc(56px + env(safe-area-inset-bottom) + 12px)' }}
      />
    </Toast.Provider>
  );
}
